import { render, staticRenderFns } from "./WorkspaceSettings.vue?vue&type=template&id=3fd3760c&scoped=true"
import script from "./WorkspaceSettings.vue?vue&type=script&lang=js"
export * from "./WorkspaceSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd3760c",
  null
  
)

export default component.exports